import * as React from "react";
import { CalendarYearApi, CalendarYearDto } from "../../../../api";
import { useTl, useApiService, useCrudApi } from "../../../../hooks";
import { useHistory } from "react-router";
import { ERoutes } from "../../../../ERoutes";
import { ETLCodes } from "../../../../locales";
import { SmallFormGenerator } from "../../../../components";
import {
  FieldGroup,
  FGTextInput,
  FGNumberInput,
  FGTextAreaInput,
} from "nsitools-react";
import * as Yup from "yup";

export interface ICalendarYearDetailPageProps {
  calendarYearId: number;
  editMode: boolean;
}

export const CalendarYearDetailPage: React.FunctionComponent<ICalendarYearDetailPageProps> = ({
  calendarYearId,
  editMode,
}) => {
  const { t } = useTl();
  const api = useApiService(CalendarYearApi);
  const history = useHistory();
  const { data, loading, saveItem, saving } = useCrudApi<CalendarYearDto>(
    {
      getApiFn: (id = calendarYearId) =>
        id > 0 ? api.getCalendarYear(id) : new CalendarYearDto().toJSON(),
      saveApiFn: (d) => api.save(d),
      onSavedRoute: (d) =>
        `${ERoutes.calendarYear}/${d.calendarYearId}/detail/edit`,
      deleteApiFn: (d) => {},
      onDeletedRoute: () => ERoutes.calendarYear,
    },
    [calendarYearId]
  );

  const FormSchema = React.useMemo(() => {
    return Yup.object().shape({
      year: Yup.string()
        .nullable()
        .required(t(ETLCodes.Required))
        .test(
          "is-unique",
          t(ETLCodes.YearAlreadyExists),
          async function (value) {
            if (!value) return false;
            // TODO: check this string=>number convertion
            const res = await api.getCalendarYearUnique(+value, calendarYearId);
            return res.value;
          }
        ),
      namingLetter: Yup.string().nullable().required(t(ETLCodes.Required)),
    });
  }, [api, calendarYearId, t]);

  return (
    data && (
      <SmallFormGenerator
        initialValues={data}
        onSubmit={saveItem}
        editMode={editMode}
        validationSchema={FormSchema}
        loading={loading}
        onCancel={() => history.push(ERoutes.calendarYear)}
        saving={saving}
      >
        <FieldGroup>
          <FGNumberInput name="year" label={t(ETLCodes.Year)} />
          <FGTextInput
            name="namingLetter"
            label={t(ETLCodes.NamingLetter)}
            maxLength={1}
            forceCase={"upper"}
          />
          <FGTextAreaInput name="remark" label={t(ETLCodes.Remark)} />
        </FieldGroup>
      </SmallFormGenerator>
    )
  );
};
